import { RangeHorizon } from '@toggle/chart';
import { SmartTableColumn } from '@toggle/design-system';
import { formatDateToLocale, Formats } from '@toggle/helpers';
import { InsightsEpisode } from '@toggle/toggle';
import React from 'react';

import { useLanguageStore } from '~/stores/use-language-store/useLanguageStore';
import { EpisodeTableRow } from '~/widgets/past-episodes-widget/components/insight-past-episodes/InsightPastEpisodes';
import sharedStyles from '~/widgets/past-episodes-widget/PastEpisodesWidget.module.scss';

export const getColumns = (
  totalTradingDays: number,
  t: (key: string, options?: any) => string
): SmartTableColumn<EpisodeTableRow>[] => [
  {
    label: t('widget:pastEpisode.table.episodeNo'),
    key: 'episodeNo',
  },
  {
    label: t('widget:pastEpisode.table.episodeDate'),
    key: 'date',
    render: value => <span className={sharedStyles.numericalValue}>{value}</span>,
  },
  {
    label: t('widget:pastEpisode.table.tradingDays', {
      totalTradingDays: totalTradingDays,
    }),
    key: 'tradingDays',
    alignment: 'right',
    render: value => <span className={sharedStyles.countValue}>{value}</span>,
  },
];

export const mapEpisodesToTableRow = (
  episodes: InsightsEpisode[]
): EpisodeTableRow[] => {
  const languageSetting = useLanguageStore.getState().languageSetting;
  return episodes.map((episode, index) => ({
    key: `episode-${index}`,
    episodeNo: index + 1,
    date: formatDateToLocale(
      languageSetting,
      new Date(episode.start_date),
      Formats['yyyy-MM-dd']
    ),
    tradingDays: episode.events.length,
  }));
};

export const getHorizonsLabels = (
  t: (key: string, options?: any) => string,
  horizons: RangeHorizon[]
) => {
  return horizons.map(horizon =>
    /* i18next-extract-mark-context-next-line ["OneMonth", "ThreeMonths", "SixMonths", "OneYear", "ThreeYears", "Max"] */
    t('widget:insights.insightHorizon', { context: horizon })
  );
};
